import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { name: '日记系列', path: '/category/diary-series' },
      { name: '短篇故事', path: '/category/short-stories' },
      { name: '连载小说', path: '/category/serial-novels' },
      { name: '热门推荐', path: '/category/hot-picks' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '读者口碑', path: '/about' },
      { name: '联系方式', path: '/about' },
    ],
  },
  {
    title: '网站信息',
    links: [
      { name: '隐私政策', path: '/about' },
      { name: '使用条款', path: '/about' },
      { name: '版权声明', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-semibold text-foreground-50 tracking-wide cursor-pointer">
              淫母日记
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              国内领先的成人日记文学阅读平台，为成年读者提供高质量的原创文学作品。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-label font-medium text-foreground-300 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors duration-200 cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 淫母日记 版权所有 | 本站内容仅供18岁以上成年读者阅读
          </p>
          <p className="text-xs text-foreground-600">
            淫母日记 - 成人日记文学在线阅读平台
          </p>
        </div>
      </div>
    </footer>
  );
}